import colors from 'styles/colors'
import styled, { css } from 'styled-components'
import { gradientBackground } from 'styles/gradients'

const ButtonBaseTheme = css`
  transition: all 0.3s ease;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  font-weight: 700;
  display: block;
  text-align: center;
  padding: 9px 15px;
  line-height: 20px;
  border-radius: 3px;
  &,
  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
  }
  &:disabled,
  [disabled] {
    cursor: auto;
    opacity: 0.7;
    &,
    &:hover,
    &:focus,
    &:active {
      opacity: 0.7;
      // background-color: initial;
      color: currentColor;
    }
  }
`

const ButtonBase = styled.button`
  ${ButtonBaseTheme}
`

const ButtonWhiteTheme = css`
  color: ${colors.main};
  background-color: ${colors.white};
  border-color: ${colors.white};
  &:hover {
    color: ${colors.main};
    background-color: ${colors.white};
    border-color: ${colors.main};
  }
`
const ButtonWhite = styled(ButtonBase)`
  ${ButtonWhiteTheme};
  border-radius: 20px;
`

const ButtonRedTheme = css`
  color: ${colors.white};
  background-color: ${colors.red};
  border-color: ${colors.red};
  &:hover {
    color: ${colors.red};
    background-color: ${colors.white};
    border-color: ${colors.red};
  }
`

const BaseSubmitButtonTheme = css`
  ${ButtonRedTheme};
  text-transform: uppercase;
  border-radius: 4px;
  letter-spacing: 0.1em;
  font-weight: 700;
  padding: 10px 15px;
`

const ButtonGradientFilled = styled.button`
  ${ButtonBaseTheme};
  background-color: var(--green-main);
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  font-size: 16px;
  transition: all 0.3s ease;
  width: 100%;
  border-radius: 100px;
  height: 42px;
  font-weight: 600;

  &:hover {
    opacity: 0.8;
  }

  &:disabled,
  [disabled] {
    &,
    &:hover,
    &:focus,
    &:active {
      opacity: 0.4;
      color: ${colors.white};
    }
  }
`

const ButtonGradient = styled.button`
  ${ButtonBaseTheme};
  display: flex;
  align-items: center;
  justify-content: center;
  ${gradientBackground};
  border: 0;

  &:after {
    position: absolute;
    content: '';
    left: 2px;
    top: 2px;
    right: 2px;
    bottom: 2px;
    background-color: ${colors.grayLightBg};
    border-radius: 18px;
    z-index: 0;
    transition: all 0.3s ease;
  }

  & > span {
    position: relative;
    z-index: 1;
    font-size: 14px;
    color: ${colors.purple};
    transition: all 0.3s ease;
  }

  &:hover {
    & > span {
      color: ${colors.white};
    }
    &:after {
      opacity: 0;
    }
  }
`

export {
  ButtonBase,
  ButtonWhite,
  ButtonBaseTheme,
  BaseSubmitButtonTheme,
  ButtonRedTheme,
  ButtonGradient,
  ButtonGradientFilled,
}
